// const baseUrl="http://localhost:8000/api";
const baseUrl="https://microfinance.goldenglobal.in/backend/public/api";

export default baseUrl;